import { faFileExport } from '@fortawesome/free-solid-svg-icons';
import { Component, EventEmitter, Output } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'stx-file-export-icon',
  templateUrl: './file-export-icon.component.html',
  styleUrls: ['./file-export-icon.component.scss'],
  imports: [FaIconComponent, MatTooltip, TranslateModule]
})
export class FileExportIconComponent {
  readonly faFileExport = faFileExport;
  @Output() download = new EventEmitter<void>();

  onClick() {
    this.download.emit();
  }
}
